import type { RiftboundCard } from '../types';

type CardArtOrientationFields = {
  orientation?: 'portrait' | 'landscape';
  cardType?: string;
};

/** True when card art is landscape and should be shown upright inside a portrait frame.
 * Battlefields are always landscape in Riftbound regardless of what the API reports,
 * so we use cardType as a reliable fallback for sets (e.g. VEN preview) where the
 * orientation field is missing from the data source. */
export function isLandscapeCardArt(card: RiftboundCard): boolean {
  return isLandscapeCardArtFields(card);
}

export function isLandscapeCardArtFields(card: CardArtOrientationFields): boolean {
  return card.orientation === 'landscape' || card.cardType === 'Battlefield';
}

/** Normalize catalog / session metadata for thumb and grid rendering. */
export function resolveCardArtMeta(
  fields: CardArtOrientationFields,
): { cardType?: string; orientation: 'portrait' | 'landscape' } {
  const cardType = fields.cardType?.trim() || undefined;
  const orientation = fields.orientation
    ?? (cardType === 'Battlefield' ? 'landscape' : 'portrait');
  return { ...(cardType ? { cardType } : {}), orientation };
}

/**
 * Portrait slot (5:7): landscape bitmap is rotated -90° so its long edge is vertical,
 * then scaled with contain so the full card stays visible (no edge cropping).
 */
export function landscapeCardArtImageProps(): {
  position: 'absolute';
  top: string;
  left: string;
  w: string;
  h: string;
  maxW: string;
  transform: string;
  objectFit: 'contain';
} {
  return {
    position: 'absolute',
    top: '50%',
    left: '50%',
    w: '140%',
    h: '71.43%',
    maxW: 'none',
    transform: 'translate(-50%, -50%) rotate(-90deg)',
    objectFit: 'contain',
  };
}
